import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { ISupplyConfigurationApi } from './base/supplyConfigurationApi';
import {
  SupplyConfigurationRequest,
  SupplyConfigurationSaveRequest
} from '../models/request';
import {
  SupplyConfigurationGetAllResponse,
  SupplyConfigurationResponse
} from '../models/response';
import { Result } from '../models/common/resultResponse';

const baseRoute: string = 'SupplyConfiguration';

export class SupplyConfigurationApi extends ISupplyConfigurationApi {
  getbysupplier(
    request: SupplyConfigurationRequest
  ): Promise<AxiosResponse<Result<SupplyConfigurationResponse[]>>> {
    return api.get(`${baseRoute}/getbysupplier`, { params: request });
  }

  getAll(
    request: SupplyConfigurationRequest
  ): Promise<AxiosResponse<Result<SupplyConfigurationGetAllResponse[]>>> {
    return api.get(`${baseRoute}/getAll`, { params: request });
  }

  saveSupplyConfiguration(
    request: SupplyConfigurationSaveRequest
  ): Promise<AxiosResponse<Result<any>, any>> {
    return api.post(`${baseRoute}`, request);
  }

  getManufacturerSupplierType(guidCountry: string): Promise<AxiosResponse<Result<SupplyConfigurationResponse[]>>> {
    return api.get(`${baseRoute}/getmanufacturersuppliertype_public`, {params: { guidCountry }});
  }
}

